import { useQuery } from '@tanstack/react-query';
import { getSymbolInfo, getTokenAvailability, getTokenBalance, getTokenData, get24hTicker } from '@/api/marketData';

export const useTokenData = (
  userId: string,
  symbol: string | null | undefined,
  exchangeCode: string | undefined,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ['market-data', 'token', userId, symbol, exchangeCode],
    queryFn: () => getTokenData(userId, symbol || '', exchangeCode),
    enabled: enabled && !!userId && !!symbol && !!exchangeCode,
    staleTime: 30 * 1000,
  });
};

export const use24hTicker = (
  userId: string,
  symbol: string | null | undefined,
  exchangeCode: string | undefined,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ['market-data', 'ticker-24h', userId, symbol, exchangeCode],
    queryFn: () => get24hTicker(userId, symbol || '', exchangeCode),
    enabled: enabled && !!userId && !!symbol && !!exchangeCode,
    staleTime: 60 * 60 * 1000, // 1 hour - data is cached for 6h on backend
  });
};

export const useTokenBalance = (
  userId: string,
  symbol: string | null | undefined,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ['market-data', 'balance', userId, symbol],
    queryFn: () => getTokenBalance(userId, symbol || ''),
    enabled: enabled && !!userId && !!symbol,
    staleTime: 30 * 1000,
  });
};

export const useSymbolInfo = (
  userId: string,
  symbol: string | null | undefined,
  exchangeCode: string | undefined,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ['market-data', 'symbol-info', userId, symbol, exchangeCode],
    queryFn: () => getSymbolInfo(userId, symbol || '', exchangeCode),
    enabled: enabled && !!userId && !!symbol && !!exchangeCode,
    staleTime: 5 * 60 * 1000,
  });
};

export const useTokenAvailability = (
  userId: string,
  symbol: string | null | undefined,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ['market-data', 'token-availability', userId, symbol],
    queryFn: () => getTokenAvailability(userId, symbol || ''),
    enabled: enabled && !!userId && !!symbol,
    staleTime: 60 * 1000,
  });
};

